<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="my-html-cover"></a><a href="https://murder-mayhem.com/newsletters" target="_blank">
<img alt="image" src="Advert/mm-backad.jpg" style="height:100%; text-align:center;"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MMad.vue?560cfa12